import { render, staticRenderFns } from "./Ideal.vue?vue&type=template&id=6c80c268&"
import script from "./Ideal.vue?vue&type=script&lang=ts&"
export * from "./Ideal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports